import { Property } from "types"
import { Location } from "types/Location";
import { BooleanFormControl } from "./BooleanFormControl"
import { DateFormControl } from "./DateFormControl"
import { NumberFormControl } from "./NumberFormControl"
import { StringFormControl } from "./StringFormControl"
import { LocationFormControl } from "./LocationFormControl"
import { MultiEditTagFormControl, addTag, removeTag } from "./MultiEditTagFormControl";

export type FormControlValue = string | number | boolean | Date | Location;

export interface FormControlProps {
    property: Property,
    value?: FormControlValue,
    tagOptions?: string[],
    onChange: (value: FormControlValue) => void,
}

export function FormControl({
        property,
        value,
        tagOptions,
        onChange,
    }: FormControlProps) {
    const { type, name } = property;
    switch (type) {
        case "boolean":
            return (
                <BooleanFormControl
                    property={property}
                    value={value as boolean}
                    onChange={onChange}
                />
            );
        case "date":
            return (
                <DateFormControl
                    property={property}
                    value={value as Date}
                    onChange={onChange}
                />
            );
        case "number":
            return (
                <NumberFormControl
                    property={property}
                    value={value as number}
                    onChange={onChange}
                />
            );
        case "string":
            return (
                <StringFormControl
                    property={property}
                    value={value as string}
                    onChange={onChange}
                />
            );
        case "spatial":
            return <LocationFormControl
                property={property}
                value={value as Location}
                onChange={onChange}
            />
        default:
            if (name === addTag || name === removeTag) {
                return (
                    <MultiEditTagFormControl
                        property={property}
                        value={value as string}
                        tagOptions={tagOptions}
                        onChange={onChange}
                    />
                );
            }
            console.error(`Unsupported property type "${type}"`);
            return null;
    }
}